export default __webpack_public_path__ + "static/media/NUG_Ideal_Broschure.dff436a2.jpg";